import { postFetch } from '../fetch';
import { apiConfig } from '../config';
import { Reaction, ReactionType, ReactionContextType } from '../../../typings';
import qs from 'query-string';

export type GetReactionsPaginationArgs = {
    page?: number | null;
    page_size?: number;
}

type ContextId = string | number;

export interface GetReactionsFilters {
    reaction_type: ReactionType;
    sender_id?: number[];
    is_viewed?: boolean;
    receiver_id?: number[];
    context_id?: ContextId[];
    context_type?: ReactionContextType;
}

export type GetReactionsResponse<T> = {
    count: number,
    next?: number | null,
    previous?: number | null,
    result: Reaction<T>[],
};

export function getReactions<T>(
    filters: GetReactionsFilters,
    paginationArgs?: GetReactionsPaginationArgs
): Promise<GetReactionsResponse<T>> {
    const { apiGetReactions } = apiConfig.getStaticUrls();

    let url = `${apiGetReactions}`;
    if (paginationArgs) {
        url = `${url}?${qs.stringify(paginationArgs)}`;
    }

    if (filters.context_id) {
        filters.context_id = filters.context_id.map(String);
    }

    return postFetch(url, { filters });
}

